import { GetPublicGalleryFnReq, GetPublicGalleryFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export interface GetPublicGalleryOptions {
  password?: string;
  pageCursor?: number;
  pageSize?: number;
}

export class GetPublicGalleryInteractor {
  private readonly fn = httpsCallable<GetPublicGalleryFnReq, GetPublicGalleryFnRes>(
    this.functions,
    'getPublicGallery',
  );

  constructor(private readonly functions: Functions) {}

  public async execute(
    slug: string,
    options: GetPublicGalleryOptions = {},
  ): Promise<GetPublicGalleryFnRes> {
    const res = await this.fn({
      slug,
      password: options.password,
      pageCursor: options.pageCursor,
      pageSize: options.pageSize,
    });
    return res.data;
  }
}
